import React from "react"
import { MDBMask, MDBView } from "mdbreact";
import {graphql, StaticQuery} from 'gatsby'


const Sponsor = () => (
    <StaticQuery query={graphql`
    {
        allWordpressWpSponsor {
          edges {
            node {
              id
              acf {
                sponsorlenke
                sponsorlogo {
                  source_url
                }
              }
            }
          }
        }
      }
    `} render={props => (

      <div className="row no-gutters">
        {props.allWordpressWpSponsor.edges.map(post => (
          <div className="col-md-4" key={post.node.id}>
            <div className="card">     
                <a href={post.node.acf.sponsorlenke}>                   
                  <MDBView hover zoom>
                    <img
                      src={post.node.acf.sponsorlogo.source_url}
                      className="img-fluid fixed-image"
                      alt="sponsor"
                    />
                    <MDBMask className="flex-center">
                      
                    </MDBMask>
                  </MDBView>
               </a>
            </div>
          </div>
        ))}
      </div>

    )} />
)

export default Sponsor;